export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./video-games.vue?vue&type=template&id=1817486a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/video-games/video-games.vue?vue&type=template&id=1817486a
// module id = 1I5m
// module chunks = 0